module.exports = __webpack_public_path__ + "static/media/red-template-small.d59ed18c.png";